import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';
import { FiX } from 'react-icons/fi';

const Modal = ({ isOpen, onClose, children, title }) => {

    // --- ИСПРАВЛЕНИЕ НАЧИНАЕТСЯ ЗДЕСЬ ---

    // 1. ВЫЗЫВАЕМ ХУК БЕЗУСЛОВНО НА ВЕРХНЕМ УРОВНЕ
    useEffect(() => {
        // 2. УСЛОВИЕ ПЕРЕНОСИМ ВНУТРЬ ХУКА
        if (isOpen) {
            // Блокируем прокрутку, только если окно открыто
            document.body.style.overflow = 'hidden';
            // Функция очистки вернет прокрутку, когда окно закроется
            return () => {
                document.body.style.overflow = 'unset';
            };
        }
    }, [isOpen]); // 3. Добавляем isOpen в зависимости, чтобы эффект реагировал на открытие/закрытие

    // 4. УСЛОВНЫЙ ВОЗВРАТ JSX ОСТАЕТСЯ ЗДЕСЬ
    // Это не нарушает правила, так как все хуки уже были вызваны выше
    if (!isOpen) {
        return null;
    }

    // --- КОНЕЦ ИСПРАВЛЕНИЯ ---

    return ReactDOM.createPortal(
        <div className={styles.backdrop} onClick={onClose}>
            <div className={styles.modalWindow} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    {title && <h3 className={styles.title}>{title}</h3>}
                    <button onClick={onClose} className={styles.closeButton} aria-label="Close modal">
                        <FiX />
                    </button>
                </div>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>,
        document.getElementById('modal-root')
    );
};

export default Modal;
